import { ReactElement } from 'react'
import { Link } from './subcomponents'

const SkipToContent = (): ReactElement => {
  return <Link href="#mainContent">skip to main content</Link>
}

export default SkipToContent
